require('./mortgagePropertyValue.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { contains } = require('lodash');

// @ utilities
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');
const { getMultiples, getTexts, getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');

// @ track processes
const { PROC_ADD_PROPERTY_VALUE, PROC_ADD_PROPERTY_CERT } = require('constants/mortgageRequestProcesses');
const { TRAMITAR_TAS, WAIT_DICTAMEN } = require('constants/mortgageRequestStates');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
const MortgageRequestErrorCustom = require('components/mortgageRequest/mortgageRequestErrorCustom/mortgageRequestErrorCustom');

// @  constants
const { TAS_CLI, TAS_CERT, TAS_CERT_CLI } = require('constants/mortgageRequestDocumentsTypes');
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');
const { TAS_UPLOADED_OR_REQUESTED } = require('constants/mortgageRequestPanelStates');
const { PEND_TASACION } = require('constants/mortgageRequestStates');
const { COMMONS: { TASACION_PHONE } } = require('constants/mortgageRequestHolderData');
const TAS_NOT_UPLOADED_NOT_VALID = [
    DOCUMENTS_STATUS.NO_VALIDO,
    DOCUMENTS_STATUS.BORRADOR,
    DOCUMENTS_STATUS.PEND_APORTAR
];
const {
    DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT,
    DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE,
    DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME,
    DRAG_N_DROP_UPLOAD_MAX_SIZE,
    DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES,
    DRAG_N_DROP_UPLOAD_TITLE,
    DRAG_N_DROP_UPLOAD_FILE_TEXT
} = require('constants/commonsComponents');

// @ actions
const mortgageRequestPropertyValueActions = require('actions/mortgageRequest/mortgageRequestPropertyValue');
const mortgageRequestEstatesActions = require('actions/mortgageRequest/mortgageRequestEstates');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');

// @ components
const { MortgagePropertyValueAppraisalState } = require('components/mortgageRequest/mortgageRequestPropertyValue/mortgagePropertyValueAppraisalState/mortgagePropertyValueAppraisalState');

class MortgagePropertyValue extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isFileSelected: false,
            isFileCertSelected: false
        };

        this.handleOnChangeFile = this.handleOnChangeFile.bind(this);
        this.handleOnSave = this.handleOnSave.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleOnRequestAppraisalClick = this.handleOnRequestAppraisalClick.bind(this);
        this.handleErrorBackClick = this.handleErrorBackClick.bind(this);
        this.handleCancelAddPropertyValue = this.handleCancelAddPropertyValue.bind(this);
    }

    componentWillMount() {
        const { summaryDocsState, requestSummaryDocumentation } = this.props;
        if (!summaryDocsState.get('documentsRequested')) {
            requestSummaryDocumentation();
        }
    }

    componentDidMount() {
        recordProcess(PROC_ADD_PROPERTY_VALUE, PROC_START);
        recordProcess(PROC_ADD_PROPERTY_CERT, PROC_START);
    }

    componentWillReceiveProps(nextProps) {
        const { uploadPropertyValue } = nextProps;

        const fileTAS = uploadPropertyValue.getIn(['files', 'fileTasacion']);
        const fileCERT = uploadPropertyValue.getIn(['files', 'fileCertificado']);

        if (
            fileTAS && uploadPropertyValue.get('uploaded') && !fileCERT ||
            fileTAS && uploadPropertyValue.get('uploaded') && fileCERT && uploadPropertyValue.get('uploadedCert') ||
            fileCERT && uploadPropertyValue.get('uploadedCert') && !fileTAS
        ) {
            this.props.history.push('/myprofile/mortgage/property-value-uploaded');
        } else {
            this.setState({
                isFileSelected: fileTAS,
                isFileCertSelected: fileCERT
            });
        }
    }

    componentWillUnmount() {
        this.props.resetView();
    }

    getCertificate() {
        const { summaryDocsState } = this.props;

        return summaryDocsState.get('data').find(file => file.get('tipoDocumentoId') === TAS_CERT)
    }

    buttonIsDisable(currentState) {
        const { mortgageRequestState, summaryDocsState } = this.props;
        const isInTramitOrApprovedAppraisalData = contains(TAS_UPLOADED_OR_REQUESTED, currentState);
        const existsFileTAS = this.existsAppraisalFile(summaryDocsState, TAS_CLI);

        let disableSaveButton = false;

        if (isInTramitOrApprovedAppraisalData ||
            !mortgageRequestState.get('idExpediente') ||
            (!this.state.isFileSelected && !existsFileTAS) ||
            (this.state.isFileCertSelected && !this.state.isFileSelected && !existsFileTAS) ||
            (!this.state.isFileSelected && !this.state.isFileCertSelected)
        ) {
            disableSaveButton = true
        }

        return disableSaveButton

    }

    existsAppraisalFile(filesList, type) {
        const file = filesList.get('data').find(file => {
            return file.get('estado') !== DOCUMENTS_STATUS.NONE &&
                file.get('estado') !== DOCUMENTS_STATUS.PEND_APORTAR &&
                file.get('tipoDocumentoId') === type;
        });

        return file ? true : false;
    }

    handleCancelAddPropertyValue(evt) {
        evt.preventDefault();
        recordProcess(PROC_ADD_PROPERTY_VALUE, PROC_CANCEL);
        recordProcess(PROC_ADD_PROPERTY_CERT, PROC_CANCEL);
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleErrorBackClick(evt) {
        evt.preventDefault();

        const { resetSummaryDocumentation, requestSummaryDocumentation } = this.props;

        resetSummaryDocumentation();
        requestSummaryDocumentation();
    }

    handleOnChangeFile(fileState) {
        const { addFile } = this.props;
        if (fileState && !fileState.error) {
            addFile(fileState);
        }
    }

    handleOnDownloadFile(fileType) {
        this.props.requestDocument({
            documentType: fileType
        });
    }

    handleOnRequestAppraisalClick() {
        const { history, mortgageRequestState, isClientWithoutAccounts } = this.props;

        if (mortgageRequestState.get('estado') === PEND_TASACION && !isClientWithoutAccounts) {
            history.push('/myprofile/mortgage/appraisal-request');
        } else if (mortgageRequestState.get('estado') === PEND_TASACION && isClientWithoutAccounts) {
            history.push('/myprofile/mortgage/appraisal-request-payment');
        } else {
            history.push('/myprofile/mortgage/property-value-issue');
        }
    }

    handleOnSave() {
        const { updateDocuments, updateCertDocuments } = this.props;
        let sendRequest = true;

        if (this.state.isFileSelected) {
            updateDocuments(sendRequest);
            sendRequest = false;
        }

        if (this.state.isFileCertSelected) {
            updateCertDocuments(sendRequest);
        }
    }

    handlePropertyValueReturnView() {
        const { uploadPropertyValue, mortgageRequestState, docCenterState, summaryDocsState } = this.props;

        const currentState = mortgageRequestState.get('estado');
        const isDisableSaveButton = this.buttonIsDisable(currentState);
        const certificate = this.getCertificate();
        const certificateState = certificate ? certificate.get('estado') : DOCUMENTS_STATUS.NONE;
        const isInTramitOrApprovedAppraisalData = contains(TAS_UPLOADED_OR_REQUESTED, currentState) || !contains(TAS_NOT_UPLOADED_NOT_VALID, certificateState);
        let content = '';
        const isFetchingTAS = docCenterState.getIn(['isFetching', TAS_CLI]) || uploadPropertyValue.get('isFetchingFile');
        const existsFileTAS = this.existsAppraisalFile(summaryDocsState, TAS_CLI);
        const isFetchingCERT = docCenterState.getIn(['isFetching', TAS_CERT]) || uploadPropertyValue.get('isFetchingCertFile');
        const existsFileCERT = this.existsAppraisalFile(summaryDocsState, TAS_CERT_CLI);
        const multiples = getMultiples(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const texts = getTexts(DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, DRAG_N_DROP_UPLOAD_MAX_SIZE, multiples, DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES);
        const textDescription = getTextDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const textLinkDescription = getTextLinkDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
        const dndTasCert = (
            <DragNDropUpload
                idName="fileCertificado"
                debug={false}
                onChange={fileState => this.handleOnChangeFile(fileState, TAS_CERT)}
                disabled={isInTramitOrApprovedAppraisalData}
                loading={isFetchingCERT}
                ammountFiles={Number(existsFileCERT)}
                overwriteFile={true}
                onDownload={() => this.handleOnDownloadFile(TAS_CERT)}
                error={!!uploadPropertyValue.get('errorCert')}
                errorMessage={uploadPropertyValue.get('errorCert')}
                texts={texts}
                title={DRAG_N_DROP_UPLOAD_TITLE}
                textDescription={textDescription}
                textLinkDescription={textLinkDescription}
                fileText={DRAG_N_DROP_UPLOAD_FILE_TEXT}
            />
        );

        if (currentState === TRAMITAR_TAS || currentState === WAIT_DICTAMEN) {
            content = (
                <MortgagePropertyValueAppraisalState
                    dndTasCert={dndTasCert}
                    onHandleCancel={this.handleCancelAddPropertyValue}
                    onSaveClick={this.handleOnSave}
                    saveButtonDisabled={isInTramitOrApprovedAppraisalData}
                />
            );
        } else {
            content = (
                <div className="mortgage-property-value">
                    <ContentBox>
                        <OKBoxTitle
                            value={formatText('mortgagePropertyValue-boxTitle')}
                            children={formatText('mortgagePropertyValue-boxSubTitle')}
                            size="medium"
                        />
                        <div className="row no-outside-gutter mortgage-property-value__request">
                            <div className="col-xs-10">
                                <label className="mortgage-property-value__label">
                                    <FormattedText value="mortgagePropertyValue-requestAppraisalTitle" />
                                </label>
                                <div className="mortgage-property-value__text">
                                    <p>
                                        <FormattedText value="mortgagePropertyValue-requestAppraisalBody" />
                                    </p>
                                </div>
                            </div>
                            <div className="col-xs-2">
                                <OKButton
                                    disabled={isInTramitOrApprovedAppraisalData}
                                    onClick={this.handleOnRequestAppraisalClick}>
                                    <FormattedText value="mortgagePropertyValue-requestAppraisal" />
                                </OKButton>
                            </div>
                        </div>
                        <hr />
                        <div className="row no-outside-gutter">
                            <div className="col-xs-12">
                                <label className="mortgage-property-value__label">
                                    <FormattedText value="mortgagePropertyValue-uploadAppraisalTitle" />
                                </label>
                                <div className="mortgage-property-value__text">
                                    <span>
                                        <FormattedText value="mortgagePropertyValue-uploadAppraisalBodyText1" />
                                    </span>
                                    <OKLink
                                        children={formatText('mortgagePropertyValue-uploadAppraisalBodyLink')}
                                        modifier="emphasize"
                                        target="_blank"
                                        to={formatText('mortgageRequestLinks-mortgageRequestLinks_appraisersList')}
                                    />
                                    <span>
                                        <FormattedText value="mortgagePropertyValue-uploadAppraisalBodyText2" />
                                    </span>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6">
                                        <label className="mortgage-property-value__sublabel">
                                            <FormattedText value="mortgagePropertyValue-uploadAppraisalSubitle" />
                                        </label>
                                    </div>
                                    <div className="col-xs-6">
                                        <label className="mortgage-property-value__sublabel">
                                            <FormattedText value="mortgagePropertyValue-uploadAppraisalCertSubitle" />
                                        </label>
                                        <div className="mortgage-property-value__text">
                                            <span>
                                                <FormattedText value="mortgagePropertyValue-uploadCertificateBodyText" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6">
                                        <DragNDropUpload
                                            idName="fileTasacion"
                                            debug={false}
                                            onChange={fileState => this.handleOnChangeFile(fileState, TAS_CLI)}
                                            disabled={isInTramitOrApprovedAppraisalData}
                                            loading={isFetchingTAS}
                                            ammountFiles={Number(existsFileTAS)}
                                            overwriteFile={true}
                                            onDownload={() => this.handleOnDownloadFile(TAS_CLI)}
                                            error={!!uploadPropertyValue.get('error')}
                                            errorMessage={uploadPropertyValue.get('error')}
                                            texts={texts}
                                            title={DRAG_N_DROP_UPLOAD_TITLE}
                                            textDescription={textDescription}
                                            textLinkDescription={textLinkDescription}
                                            fileText={DRAG_N_DROP_UPLOAD_FILE_TEXT}
                                        />
                                    </div>
                                    <div className="col-xs-6">
                                        {dndTasCert}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-10 mortgage-property-value__margin-button">
                                <OKLink
                                    onClick={this.handleCancelAddPropertyValue}
                                >
                                    <FormattedText value="mortgagePropertyValue-backText" />
                                </OKLink>
                            </div>
                            <div className="col-md-2">
                                <div className="mortgage-property-value__right-content">
                                    <OKButton
                                        onClick={this.handleOnSave}
                                        loading={uploadPropertyValue.get('isFetching') ||
                                            uploadPropertyValue.get('isFetchingCert')}
                                        disabled={isDisableSaveButton}
                                    >
                                        <FormattedText value="mortgagePropertyValue-save" />
                                    </OKButton>
                                </div>
                            </div>
                        </div>
                    </ContentBox>
                </div>
            );
        }

        return content;
    }

    render() {
        const { summaryDocsState } = this.props;

        if (!summaryDocsState.get('documentsRequested')) {
            return <LoadingSection />;
        }

        if (summaryDocsState.get('error') !== '') {
            return (
                <MortgageRequestErrorCustom
                    columns={12}
                    errorTitle={formatText('mortgagePropertyValueError-errorRequestTitle')}
                    goBackButtonLabel={formatText('mortgagePropertyValueError-errorRequestLink')}
                    onGoBackButtonClick={this.handleErrorBackClick}
                >
                    <div className="mortgage-request-property-value-error__text">
                        <p>{formatText('mortgagePropertyValueError-errorRequestText', [TASACION_PHONE])}</p>
                    </div>
                </MortgageRequestErrorCustom>
            );
        }

        const content = this.handlePropertyValueReturnView();
        return (
            <div>
                {content}
            </div>
        );
    }
}

MortgagePropertyValue.propTypes = {
    history: PropTypes.object.isRequired,
    uploadPropertyValue: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    summaryDocsState: PropTypes.object,
    docCenterState: PropTypes.object,
    updateDocuments: PropTypes.func,
    updateCertDocuments: PropTypes.func,
    addFile: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
    resetSummaryDocumentation: PropTypes.func,
    requestDocument: PropTypes.func,
    isClientWithoutAccounts: PropTypes.bool,
    resetDocumentsState: PropTypes.func,
    resetView: PropTypes.func.isRequired,
    uploadFile: PropTypes.func
};

module.exports.constructor = MortgagePropertyValue;

module.exports.MortgagePropertyValue = connect(state => ({
    uploadPropertyValue: state.mortgageRequestPropertyValue,
    mortgageRequestState: state.mortgageRequestState,
    summaryDocsState: state.mortgageRequestSummaryDocumentation,
    docCenterState: state.mortgageRequestDocumentationCenter
}), {
        updateDocuments: mortgageRequestPropertyValueActions.updateDocuments,
        updateCertDocuments: mortgageRequestPropertyValueActions.updateCertDocuments,
        addFile: mortgageRequestPropertyValueActions.addFile,
        requestSummaryDocumentation: mortgageRequestEstatesActions.fetchSimpleNotes,
        resetSummaryDocumentation: mortgageRequestEstatesActions.resetSummaryDocumentation,
        requestDocument: documentActions.getDocument,
        resetView: mortgageRequestPropertyValueActions.resetView,
        uploadFile: documentActions.uploadFile
    })(withRouter(MortgagePropertyValue));
